import type { NextPage } from 'next';
import { NextSeo } from 'next-seo';

import { DEFAULT_SEO_CONFIG, ROOT_URL_PRODUCTION } from '../../next-seo.config';
import { LiquiditySourcesLanding } from '../components/LiquiditySourcesLanding';
import { routes } from '../utils/routes';

const LIQUIDITY_SOURCES_TITLE = 'Liquidity from 130+ DEXs';
const LIQUIDITY_SOURCES_DESCRIPTION =
  'Deep liquidity for the best prices on over 9 million tokens. Tap into 130+ liquidity sources including private market makers and AMMs with Matcha DEX aggregator!';

const LiquiditySourcesPage: NextPage = () => {
  return (
    <>
      <NextSeo
        {...DEFAULT_SEO_CONFIG}
        title={LIQUIDITY_SOURCES_TITLE}
        description={LIQUIDITY_SOURCES_DESCRIPTION}
        canonical={`${ROOT_URL_PRODUCTION}${routes.LIQUIDITY_SOURCES}`}
        openGraph={{
          images: [
            {
              url: `${ROOT_URL_PRODUCTION}/images/og/social-liquidity-sources-banner.jpg`,
              width: 1200,
              height: 630,
              alt: 'Matcha',
            },
          ],
        }}
        additionalMetaTags={[
          {
            name: 'twitter:title',
            content: LIQUIDITY_SOURCES_TITLE,
          },
          {
            name: 'twitter:description',
            content: LIQUIDITY_SOURCES_DESCRIPTION,
          },
          {
            name: 'twitter:image',
            content: `${ROOT_URL_PRODUCTION}/images/og/social-liquidity-sources-banner.jpg`,
          },
          {
            name: 'twitter:url',
            content: `${ROOT_URL_PRODUCTION}${routes.LIQUIDITY_SOURCES}`,
          },
        ]}
      />
      <LiquiditySourcesLanding />
    </>
  );
};

export default LiquiditySourcesPage;
